import { signIn, getSession } from '../auth.js';
import { navigate } from '../router.js';

export function render(mountEl) {
  // In demo mode the user is always already signed in, so this page is
  // unreachable via the normal flow. Anyone who does hit it (direct URL,
  // bookmark) gets bounced to the tracks list.
  if (getSession()) {
    navigate('#/tracks');
    return;
  }

  mountEl.innerHTML = `
    <section class="page page-login">
      <h1>Sign in</h1>
      <form id="login-form" class="form">
        <label>
          Email
          <input type="email" name="email" required autocomplete="email">
        </label>
        <label>
          Password
          <input type="password" name="password" required autocomplete="current-password">
        </label>
        <button type="submit">Sign in</button>
        <p id="login-error" class="error" role="alert"></p>
      </form>
    </section>
  `;

  const form = mountEl.querySelector('#login-form');
  const errorEl = mountEl.querySelector('#login-error');
  form.addEventListener('submit', async e => {
    e.preventDefault();
    errorEl.textContent = '';
    const fd = new FormData(form);
    const result = await signIn(fd.get('email'), fd.get('password'));
    if (result?.error) {
      errorEl.textContent = result.error;
    } else {
      navigate('#/tracks');
    }
  });
}
